const initialState = {
    isLoading: false,
    simulationSummary: {},
    errorSimulationSummary: false,
};

const simulationSummary = (state = initialState, { type, ...payload }) => {
    switch (type) {
        case 'SET_SIMULATION_SUMMARY':
            return {
                errorSimulationSummary: false,
                simulationSummary: payload.simulationSummary,
                isLoading: false,
            };
        case 'SET_ERROR_SIMULATION_SUMMARY':
            return {
                errorSimulationSummary: payload.errorSimulationSummary,
                simulationSummary: {},
                isLoading: false,

            };
        case 'SET_SIMULATION_SUMMARY_LOADING':
            return {
                isLoading: true,
                errorSimulationSummary: false,
                simulationSummary: {},
            };
        case 'RESET_SIMULATION_SUMMARY':
            return initialState;
        default:
            return state;
    }
};

export default simulationSummary;
